/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.partners.controllers', [])

.controller('PartnersController', ['$scope', function($scope) {

    $scope.partners = {

      model: "Your spankin new application.partners.default view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.partners.init();

}]);